//React
import React from 'react';

import { SubmissionManagement } from 'pages/submissions';
import { useAdminSubmissionManagementData } from './useAdminSubmissionManagementData';

export const AdminSubmissionManagement: React.FC = () => {
  const { submissions, payors, isLoading, isError, isFetching, errorMessage } =
    useAdminSubmissionManagementData();
  return (
    <SubmissionManagement
      submissions={submissions}
      payors={payors}
      isLoading={isLoading}
      isError={isError}
      isFetching={isFetching}
      errorMessage={errorMessage}
    />
  );
};
